
































































































import { Component, Emit, Inject, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import Actions from '../Actions.vue';
import DeleteConfirmation from './DeleteConfirmation.vue';
import { Method, EventBus, TypeEventBus, itemsPerPageOptionsTable } from '../../../core/utils';
import { RootStoreHelper } from '../../../core/mixins';
import { IDescription, Geofence } from '../../../core/models';
import { MarkStateStore } from '../../components/Geofences/marks.state';
import Input from '../../../core/components/Input.vue'; 
import Item from './Item.vue';
import vColumnsResizable from '../../../../plugins/vue-columns-resizable'
import { getGeofenceAlertForDeletion, getPointOfInterestAlertForDeletion, getSingleGeofenceAlertForDeletion } from '../../../tracking/utils';
import UploadPointsOrGeofences from '../PointsOfInterests/UploadPointsOrGeofences.vue'
@Component<ManagementGeofences>({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: { DeleteConfirmation, Actions, Item, Input, UploadPointsOrGeofences }
})
export default class ManagementGeofences extends Mixins(RootStoreHelper) {
    @Prop() elements: IDescription[];
    @Prop() selected: IDescription[];
    @Prop() filter: string;
    @Prop() tab: string;
    @Prop() loadingDelete: boolean;
    @Prop({ default: '' }) hintAdd: string;
    @Prop({ default: '' }) hintRemove: string;
    @Prop({ default: '' }) hintFilters: string;
    @Prop({ default: '' }) hintEdit: string;
    @Inject() disableListenKey: Method<boolean, void>;
    @Provide() geoFencesStore: MarkStateStore<Geofence> = new MarkStateStore<Geofence>();
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    deleteConfirmationBody: string = '';
    search: string = '';
    openConfirmation: boolean = false;
    visibleUploadFile: boolean = false;
    geofenceSelected: any = [];
    summaryDeleteConfirmation: string[] = [];

    updateSearchValue(value){
        this.search = value;
    }

    updateGeofenceSelected(options) {
        this.geofenceSelected = options;
    }

    updateSummaryDeleteConfirmation(value: string[]) {
        this.summaryDeleteConfirmation = value;
    }

    updateDeleteConfirmationBody(value: string) {
        this.deleteConfirmationBody = value;
    }

    headers: any = [
        {
            text: 'Seleccionar todo',
            value: 'description',
            align: 'left'
        },
        {
            text: '',
            value: 'geofence_type',
            filter: this.filterGeofenceType,
            class: 'hide-header'
        }
    ];

    filterGeofenceType(value) {
        if (value == null) {
            value = 9999;
        }

        let gfFilter = this.$_getGeofencesFilter;
        let checkedItems = gfFilter.filter(item => item['checked'] == true);
        if (checkedItems.length == 0) {
            return true;
        }

        for (let i = 0; i < gfFilter.length; i++) {
            let item = gfFilter[i];
            if (item['checked']) {
                if (item['id'] == value) {
                    return item;
                }
            }
        }
    }

    @Emit()
    selectElements(selectedElements: IDescription[]): void {}

    @Emit()
    addSelectElement(selectedElement: IDescription, selected: boolean) {}

    @Emit()
    changeFilter(filter: string): void {}

    @Emit()
    refreshPointsOfInterest(): void {}

    @Emit()
    deleteElements(selectedElements: IDescription[]): void {}

    toggleAll() {
        if (this.selected.length) {
            this.selectElements([]);
        } else {
            this.selectElements([...this.elements]);
        }
    }

    handleSelectOne(selectedElement: IDescription, selected: boolean): void {
        this.addSelectElement(selectedElement, selected);
    }

    getGeofenceTypeName(type) {
        let geocercasValues: any = Object.values(this.$_getGeofencesTypes);
        let geocercasKeys: any = Object.keys(this.$_getGeofencesTypes);
        if (type) {
            for (let i = 0; i < geocercasValues.length; i++) {
                if (geocercasValues[i].id === type) {
                    return geocercasValues[i].value;
                }
            }
        } else {
            return 'Genérica';
        }
    }

    customFilter(items, search, filter) {
        let userSearch = this.removeAccentsFromString(search.toLowerCase());
        let filterGeofenceDescription = this.removeAccentsFromString(filter.description.toString().toLowerCase());
        let filterGeofenceType;
        if (filter.geofence_type) {
            filterGeofenceType = this.removeAccentsFromString(
                this.getGeofenceTypeName(filter.geofence_type)
            ).toLowerCase();
            return filterGeofenceDescription.includes(userSearch) || filterGeofenceType.includes(userSearch);
        } else {
            return filterGeofenceDescription.includes(userSearch);
        }
    }

    removeAccentsFromString = str => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };

    get isOneElementSelected(): boolean {
        return this.selected.length !== 1;
    }

    get isMultiplesElementSelected(): boolean {
        return this.selected.length <= 0;
    }

    get isGeofence() {
        return this.tab === 'geofencesTab' ? true : false;
    }

    handleDelete(): void {
         let pointsOrGeofences:any = this.selected as Geofence[];
        if (this.selected.length == 1) {
            if(this.isGeofence){
                this.deleteConfirmationBody = getSingleGeofenceAlertForDeletion(pointsOrGeofences[0]);
            }else{
                this.deleteConfirmationBody = getPointOfInterestAlertForDeletion(pointsOrGeofences)
            }
        } else {
           
            if(this.isGeofence){
                this.deleteConfirmationBody = getGeofenceAlertForDeletion(pointsOrGeofences);
            }else{
                this.deleteConfirmationBody = getPointOfInterestAlertForDeletion(pointsOrGeofences)
            }
        }


        this.openConfirmation = true;
    }

    handleConfirmation(confirmation: boolean): void {
        if (confirmation) {
            this.deleteElements(this.selected);
        } else {
            this.setOpenConfirmation(false);
        }
    }

    handleEdit(): void {
        this.editElement(this.selected[0]);
    }

    uploadFile(tab): void {
        //recibo la tab (geocerca o punto de interés)
        console.log("subo archivo tab", tab);
        this.visibleUploadFile = true;
    }

    setOpenConfirmation(value: boolean): void {
        this.openConfirmation = value;
    }

    @Emit()
    addElement() {}

    @Emit()
    editElement(element: IDescription) {}

    @Emit()
    center(centerElement: IDescription) {}
}
